import { useState } from 'react';
import axios from 'axios';
import { AccountBalanceRequest, AccountBalanceResponse } from 'vopay';
import apiConfig from '@/services/api.config';

const { api } = apiConfig;

export type AccountBalance = Omit<AccountBalanceResponse, 'Success' | 'ErrorMessage'>;

export default function useFetchAccountBalance() {
  const [fetching, setFetching] = useState(false);
  const source = axios.CancelToken.source();
  const [accountBalance, setAccountBalance] = useState<AccountBalance | null>(null);

  async function fetchAccountBalance(req: AccountBalanceRequest) {
    try {
      setFetching(true);
      const res = await api.postAccountBalance(req, source);

      if (!res.Success) throw new Error(res.ErrorMessage);

      setAccountBalance(res);

      return res;
    } finally {
      setFetching(false);
    }
  }

  return {
    fetching,
    accountBalance,
    fetchAccountBalance,
  };
}
